import React from 'react';
import { useAuthorization } from 'framework/authorization';
import { ShowSection } from 'framework/ui/layout';
import type { Data } from 'framework/types';

const EmployeeSectionWrapper = ({
  children,
  permissions,
  withMinHeight = true,
  fullHeight = false,
  title,
  isVisible = true,
}: {
  children: React.ReactNode;
  permissions?: string | string[];
  withMinHeight?: boolean;
  fullHeight?: boolean;
  isVisible?: boolean;
  title?: string | React.ReactElement | ((data: Data) => string | React.ReactElement);
}) => {
  const { isGranted } = useAuthorization();

  if (!isVisible || (permissions && !isGranted(permissions))) {
    return null;
  }

  return (
    <ShowSection
      title={title}
      sx={(theme: any) => ({
        padding: '22px 20px 20px !important',
        [theme.breakpoints.down('md')]: {
          padding: '18px 16px 18px !important',
        },
        ...(fullHeight && {
          height: 'calc(100% - 20px)',
          display: 'flex',
          flexDirection: 'column',
        }),
        minHeight: withMinHeight ? '200px' : 'unset',
        '.section-details__wrapper': {
          p: '0 !important',
          ...(fullHeight && {
            height: 'calc(100% - 20px)',
            display: 'flex',
            flexDirection: 'column',
          }),
        },
      })}
    >
      {children}
    </ShowSection>
  );
};

export default EmployeeSectionWrapper;
